import React from 'react';
import { Link } from "react-router-dom";
import "./style.less";

export interface IMenu{
	showHidden: boolean;
}

export default function Menu({
	showHidden = false,
} : IMenu) {
	return <div className="menu">
		<ul className="menu__list">
			<Link to="/">
				<li className="menu__list__item first">Hlavní stránka</li>
			</Link>
			<Link to="/program">
				<li className="menu__list__item">Program</li>
			</Link>
			<Link to="/oznameni">
				<li className="menu__list__item">Oznámení</li>
			</Link>
			<Link to="/ubytovani">
				<li className="menu__list__item">Ubytování</li>
			</Link>
			<Link to="/zasedaci-poradek">
				<li className="menu__list__item">Zasedací pořádek</li>
			</Link>
			{ showHidden
				? <>
					<Link to="/martinek">
						<li className="menu__list__item">Martínek</li>
					</Link>
					<Link to="/tanec">
						<li className="menu__list__item">Tanec</li>
					</Link>
				</>
				: null
			}
			<Link to="/colors">
				<li className="menu__list__item">Barvy svatby</li>
			</Link>
			{ showHidden
				? <Link to="/messenger">
					<li className="menu__list__item">Messenger</li>
				</Link>
				: null
			}
			<Link to="/map">
				<li className="menu__list__item">Mapa</li>
			</Link>
		</ul>
	</div>;
}
